import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DashboardHeader from '../../Header/DashboardHeader';
import DashboardFooter from '../../Footer/DashboardFooter';
import DashboardLeftMenu from '../../Dashboard/DashboardLeftMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faEye, faDownload } from '@fortawesome/free-solid-svg-icons';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { HOST_URL } from '../api/Api';
import Spining from "../../UI/Spining/Spining";
import Axios from '../../../axios/Axios';
import { handleUserLog } from '../../Utils/Utils';
class WhatsAppCountReports extends Component {

    constructor() {

        const lStorage = JSON.parse(localStorage.getItem("login"));
        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;

        var today = new Date(),
            date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + ("0" + today.getDate()).slice(-2);
        super();
        this.state = {
            user_id: userId,
            token: userToken,
            TodayDate: date,
            loading: false,
            channel: 'wp',
            smsReports: '',
            smsReportsKeys: '',
            voiceReports: '',
            voiceReportsKeys: '',
            emailReports: '',
            emailReportsKeys: '',
            dateFrom: date,
            dateTo: date,
            SelecteddateFrom: '',
            SelecteddateTo: '',
            errorMessage: '',
            successMessage: false,
            smsSuccessMessage: false,
            voicesuccessMessage: false,
            emailSuccessMessage: false,
            resultUpdate: false,
            bgColor: '',
        }

        this.FilterDateWise = this.FilterDateWise.bind(this);
        this.resultUpdateTimeout = null;

    }

    componentDidMount() {
        this.smsReportSummery(this.state.TodayDate, this.state.TodayDate);
    }

    componentWillUnmount() {
        if (this.resultUpdateTimeout) {
            clearTimeout(this.resultUpdateTimeout);
        }
    }


    smsReportSummery = async (dateFrom, dateTo) => {
        let paramData = {
            user_id: this.state.user_id,
            method: "summary",
            token: this.state.token,
            date_from: dateFrom,
            date_to: dateTo
        }
        let { data } = await Axios.post(`${HOST_URL}/whatsapp_report.php`, paramData)
        if (data.success === true) {
            this.setState({ smsReports: data.message, smsReportsKeys: data.message });
        } else {
            this.setState({ smsSuccessMessage: true, errorMessage: data.message, bgColor: "alert alert-danger alert-dismissible" })
        }
    }

    dataDownload() {
        this.setState({ successMessage: false });
        var date1 = new Date(this.state.dateFrom);
        var date2 = new Date(this.state.dateTo);
        var Difference_In_Time = date2.getTime() - date1.getTime();
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

        if (Math.trunc(Difference_In_Days) <= 15) {
            const formData = new FormData();
            formData.append("user_id", this.state.user_id);
            formData.append("method", "download");
            formData.append("channel", "wp");
            formData.append("token", this.state.token);
            formData.append("date_from", this.state.dateFrom);
            formData.append("date_to", this.state.dateTo);

            fetch(`${HOST_URL}/user_report.php`, {
                method: "POST",
                body: formData
            })
                .then(response => {
                    if (!response.ok) throw new Error("Network error");
                    return response.blob();
                })
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "user_report.csv";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                })
                .catch(error => {
                    console.error("Download failed:", error);
                });
        } else {
            document.querySelector("body").scrollTo(0, 0);
            this.setState({
                successMessage: true,
                bgColor: "alert alert-danger alert-dismissible",
                errorMessage: `Please go to the Download Center to download data older than 15 days.`,
            });
        }
    }




    async FilterDateWise() {
        if (this.resultUpdateTimeout) {
            clearTimeout(this.resultUpdateTimeout);
        }
        this.setState({ loading: true });
        this.setState({ resultUpdate: true, errorMessage: "Result Updated", bgColor: "alert alert-success alert-dismissible" })
        try {
            await this.smsReportSummery(this.state.dateFrom, this.state.dateTo);
        } finally {
            this.setState({ loading: false });
        }
        this.resultUpdateTimeout = setTimeout(() => {
            this.resultUpdateTimeout = null;
            this.setState({ resultUpdate: false })
        }, 5000);
    }


    dateFrom = (date) => {
        let dated = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ("0" + date.getDate()).slice(-2);
        this.setState({
            dateFrom: dated,
            SelecteddateFrom: date
        });
    };

    dateTo = (date) => {
        let dated = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ("0" + date.getDate()).slice(-2);
        this.setState({
            dateTo: dated,
            SelecteddateTo: date
        });
    };

    render() {
        return (
            <div className="wrapper">
                <DashboardLeftMenu />
                <div className="main">
                    <DashboardHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className=" mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3><strong>WhatsApp</strong> Reports </h3>
                                </div>
                            </div>
                            <div className="">
                                <div className="card">
                                    {this.state.loading === true && <Spining />}
                                    <div className="">
                                        <h5 className="card-title mt-5">
                                            <div className="col-auto ml-auto text-right mt-n1">
                                                <nav className="text-center" aria-label="breadcrumb">
                                                    <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                                                        <Link to="/dashboard/whatsapp-report"><li onClick={() => handleUserLog("", "clicked_today_summary_tab", "whatsapp", "User Click on Today Summary tab in report", "whatsapp_report", "", "")} className="breadcrumb-item active"> Today's Summary </li> </Link>
                                                        <Link to={'/dashboard/whatsapp-detail-reports/' + this.state.dateFrom + '/' + this.state.dateTo}> <li onClick={() => handleUserLog("", "clicked_detailed_reports_tab", "whatsapp", "User Click on Detailed Reports tab in report", "whatsapp_report", "", "")} className="breadcrumb-item "> Detailed Reports </li> </Link>

                                                    </ol>
                                                </nav>
                                            </div>
                                        </h5>
                                    </div>

                                    <div className="card-body">
                                        <div className="filter-option">
                                            <h6 className="card-subtitle text-muted">Select Data Range  </h6>
                                            <div className="row">
                                                <div className="col-md-1">
                                                    <div className="btn-block mb-2 mr-sm-2">
                                                        <label
                                                            className="mt-2"
                                                            for="inlineFormCustomSelectPref"
                                                        >
                                                            From
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-4">
                                                    <div className="input-group mb-2 mr-sm-2">
                                                        <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                                                            <FontAwesomeIcon icon={faCalendarAlt} />
                                                        </div>
                                                        <DatePicker
                                                            className="form-control"
                                                            dateFormat="yyyy/MM/dd"
                                                            value={this.state.dateFrom}
                                                            onChange={this.dateFrom}
                                                            selected={this.state.SelecteddateFrom}
                                                            placeholderText="From Date"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="btn-block mb-2 mr-sm-2">
                                                        <label
                                                            className="mt-2"
                                                            for="inlineFormCustomSelectPref"
                                                        >
                                                            To
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-4">
                                                    <div className="input-group mb-2 mr-sm-2 d-flex">
                                                        <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                                                            <FontAwesomeIcon icon={faCalendarAlt} />
                                                        </div>
                                                        <DatePicker
                                                            className="form-control"
                                                            dateFormat="yyyy/MM/dd"
                                                            value={this.state.dateTo}
                                                            onChange={this.dateTo}
                                                            selected={this.state.SelecteddateTo}
                                                            placeholderText="Date To"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-2">
                                                    <div className="input-group btn-block mb-2 mr-sm-2">
                                                        <button
                                                            onClick={() => {
                                                                this.FilterDateWise();
                                                            }}
                                                            className="btn mt-1 btn-blue btn-sm  btn-block"
                                                        >
                                                            Search{" "}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        {
                                            this.state.resultUpdate ?
                                                <div className={this.state.bgColor} role="alert">
                                                    <button type="button" className="close" aria-label="Close" onClick={() => this.setState({ resultUpdate: false })}>
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                    <div className="">
                                                        {this.state.errorMessage}
                                                    </div>
                                                </div>
                                                :
                                                null
                                        }

                                        {
                                            this.state.successMessage ?
                                                <div className={this.state.bgColor} role="alert">
                                                    <button type="button" className="close" aria-label="Close" onClick={() => this.setState({ successMessage: false })}>
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                    <div className="">
                                                        {this.state.errorMessage}
                                                    </div>
                                                </div>
                                                :
                                                null
                                        }


                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h4 className="summary-title">WhatsApp</h4>


                                                        {
                                                            this.state.smsSuccessMessage ?
                                                                <div className={this.state.bgColor} role="alert">
                                                                    <button type="button" className="close" aria-label="Close" onClick={() => this.setState({ smsSuccessMessage: false })}>
                                                                        <span aria-hidden="true">×</span>
                                                                    </button>
                                                                    <div className="">
                                                                        {this.state.errorMessage}
                                                                    </div>
                                                                </div>
                                                                :
                                                                null
                                                        }


                                                        {this.state.smsReports ?
                                                            <div className="d-flex flex-wrap summary-data text-center">

                                                                <div className="mb-1">
                                                                    <span className="text-muted"> Total  </span> <br /> <Link to={'/dashboard/whatsapp-detail-reports/' + this.state.dateFrom + '/' + this.state.dateTo}> <span className="text-success"> {this.state.smsReportsKeys.total || 0} </span> </Link>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <span className="text-muted"> Delivered  </span> <br /> <Link to={'/dashboard/whatsapp-detail-reports/' + this.state.dateFrom + '/' + this.state.dateTo}> <span className="text-success"> {this.state.smsReportsKeys.delivered || 0} </span> </Link>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <span className="text-muted"> Failed  </span> <br /> <Link to={'/dashboard/whatsapp-detail-reports/' + this.state.dateFrom + '/' + this.state.dateTo}> <span className="text-success"> {this.state.smsReportsKeys.failed || 0} </span> </Link>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <span className="text-muted"> Sent  </span> <br /> <Link to={'/dashboard/whatsapp-detail-reports/' + this.state.dateFrom + '/' + this.state.dateTo}> <span className="text-success"> {this.state.smsReportsKeys.sent || 0} </span> </Link>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <span className="text-muted"> Read  </span> <br /> <Link to={'/dashboard/whatsapp-detail-reports/' + this.state.dateFrom + '/' + this.state.dateTo}> <span className="text-success"> {this.state.smsReportsKeys.read || 0} </span> </Link>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <span className="text-muted"> Optout  </span> <br /> <Link to={'/dashboard/whatsapp-detail-reports/' + this.state.dateFrom + '/' + this.state.dateTo}> <span className="text-success"> {this.state.smsReportsKeys.optout || 0} </span> </Link>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <span className="text-muted"> Submitted </span> <br /> <Link to={'/dashboard/whatsapp-detail-reports/' + this.state.dateFrom + '/' + this.state.dateTo}> <span className="text-success"> {(this.state.smsReportsKeys.submitted || 0) + (this.state.smsReportsKeys.Submitted || 0)} </span> </Link>
                                                                </div>


                                                                <div className="mb-1">
                                                                    <span className="text-muted"> View  </span> <br /> <Link to={'/dashboard/whatsapp-detail-reports/' + this.state.dateFrom + '/' + this.state.dateTo}> <span onClick={() => handleUserLog("", "whatsapp_report_opened", "whatsapp", "User Click on View Button in report", "whatsapp_report", "", { date_from: this.state.dateFrom, date_to: this.state.dateTo })} className="text-success">
                                                                        <FontAwesomeIcon icon={faEye} />
                                                                    </span> </Link>
                                                                </div>


                                                                <div className="mb-1">
                                                                    <span className="text-muted"> Download  </span> <br /> <span onClick={() => {
                                                                        handleUserLog("", "whatsapp_report_downloaded", "whatsapp", "User Click on Download Button in report", "whatsapp_report", "", { date_from: this.state.dateFrom, date_to: this.state.dateTo });
                                                                        this.dataDownload();
                                                                    }} className="text-success" style={{ cursor: 'pointer' }}>
                                                                        <FontAwesomeIcon icon={faDownload} />
                                                                    </span>
                                                                </div>





                                                            </div>
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <DashboardFooter />
                </div>
            </div>
        );
    }
}
export default WhatsAppCountReports;